export const PAYMENT_MODES_STORAGE_KEYS = {
    ADD_NEW_CARD: "add_card_details",
    MANAGE_CARD: "manage_card_details",
    CARD_DETAILS: "card_details",
};
